import clsx from "clsx";
import Router from "next/router";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useAuthenticationStore } from "@sol/authentication/useAuthenticationStore";
import { Route } from "@sol/routing";

type Props = {
    status: number;
    className?: string;
};

const HttpErrorDisplay = ({ status, className }: Props) => {
    const [t] = useTranslation();

    useEffect(() => {
        if (status !== 401) {
            return;
        }

        useAuthenticationStore.getState().logout();
        Router.push(Route.LOGIN);
    }, [status]);

    const message = useMemo(() => {
        switch (status) {
            case 400:
                return t("errors.badRequest");
            case 404:
                return t("errors.notFound");
            case 403:
            case 405:
                return t("errors.notAllowed");
            case 500:
                return t("errors.internalServerError");
            default:
                return t("errors.default");
        }
    }, [status]);

    if (status === 401) {
        return null;
    }

    return (
        <div
            className={clsx(
                "font-sans flex h-screen items-center justify-center text-base leading-6 font-bold",
                className,
            )}
        >
            {message}
        </div>
    );
};

export default HttpErrorDisplay;
